module.exports = __webpack_public_path__ + "static/img/team_honor_champion.d33f674e.png";